import React, { type ReactNode } from 'react';

import { MainContainer } from '../../../components/MainContainer/MainContainer';
import { Loading } from '../../../components/Loading/Loading';
import { ForbiddenError } from '../../Trader/Errors/ForbiddenError';
import { useGetUserTypeQuery } from '../../../redux/services/SupportApi';
import styles from '../Analyst.module.css';

// Страницы аналитика видны только типу "analyst"; данные запрашиваются уже внутри, после проверки роли
export const AnalystPage = ({ title, hint, children }: { title: string; hint?: ReactNode; children: ReactNode }) => {
  const { data: userType, isLoading } = useGetUserTypeQuery();
  if (isLoading) return <Loading />;
  if (userType !== 'analyst') return <ForbiddenError />;
  return (
    <MainContainer>
      <div className={'cards'} style={{ height: '100%' }}>
        <div className={styles.wrapper}>
          <h1>{title}</h1>
          {hint && <p className={styles.hint}>{hint}</p>}
          {children}
        </div>
      </div>
    </MainContainer>
  );
};
